import Wine from "./Wine";

export default Wine;